
namespace Matrix.Workflow {

    @Serenity.Decorators.registerEditor('Matrix.Workflow.TaskInstanceDocumentGrid')
    @Serenity.Decorators.element("<div/>")
    export class TaskInstanceDocumentGrid extends SiteEntityGrid<TaskInstanceDocumentRow, any> {
        protected getColumnsKey() { return 'Workflow.TaskInstanceDocument'; }
        protected getDialogType() { return TaskInstanceDocumentDialog; }
        protected getIdProperty() { return TaskInstanceDocumentRow.idProperty; }
        protected getLocalTextPrefix() { return TaskInstanceDocumentRow.localTextPrefix; }
        protected getService() { return TaskInstanceDocumentService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getInitialTitle() {
            return null;
        }

        protected getAddButtonCaption() {
            return "New Document";
        }

        protected usePager() {
            return false;
        }

        protected addButtonClick() {
            if (!this.taskInstanceId) {
                Q.notifyError("Please save the task instance first!");
                return;
            }

            this.editItem(<TaskInstanceDocumentRow>{
                TaskInstanceId: this.taskInstanceId,
                DocumentGroup: "upload"
            });
        }

        private _taskInstanceId: number;

        get taskInstanceId() {
            return this._taskInstanceId;
        }

        set taskInstanceId(value: number) {
            if (this._taskInstanceId !== value) {
                this._taskInstanceId = value;
                this.setEquality(TaskInstanceRow.Fields.TaskInstanceId, value);
                this.refresh();
            }
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this._taskInstanceId;
        }

        protected getColumns() {
            var columns = super.getColumns();

            var injectIndex = Q.indexOf(columns, x => x.field ==
                TaskInstanceDocumentRow.Fields.DocumentName) + 1;

            columns.splice(injectIndex, 0,
                {
                    width: 32,
                    minWidth: 32,
                    maxWidth: 32,
                    field: 'Download',
                    name: '',
                    format: ctx => {
                        return '<a class="inline-action download-file" title="download"><i class="fa fa-download text-purple"></i></a>';
                    },
                    sortable: false,
                    headerFilterType: Serenity.HeaderFilterType.disabled
                });

            //columns.splice(injectIndex + 1, 0,
            //    {
            //        width: 32,
            //        minWidth: 32,
            //        maxWidth: 32,
            //        field: 'View',
            //        name: '',
            //        format: ctx => {
            //            return '<a class="inline-action view-file" title="view"><i class="fa fa-search text-maroon"></i></a>';
            //        },
            //        sortable: false,
            //        headerFilterType: Serenity.HeaderFilterType.disabled
            //    });

            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row) as TaskInstanceDocumentRow;
            var target = $(e.target);

            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (!target.hasClass('inline-action'))
                return;

            e.preventDefault();

            if (target.hasClass('download-file') ||
                target.hasClass('view-file')) {
                TaskInstanceDocumentService.Retrieve({
                    EntityId: item.TaskInstanceDocumentId,
                    ColumnSelection: Serenity.RetrieveColumnSelection.keyOnly,
                    IncludeColumns: [
                        TaskInstanceDocumentRow.Fields.DocumentContent,
                        TaskInstanceDocumentRow.Fields.DocumentType,
                        TaskInstanceDocumentRow.Fields.DocumentName
                    ]
                }, response => {
                    downloadBase64Content(response.Entity.DocumentContent as any,
                        response.Entity.DocumentName, response.Entity.DocumentType, target.hasClass('view-file'));
                });
            }
        }


    }
}